import { render, staticRenderFns } from "./NswEventsTemplate.vue?vue&type=template&id=ef636322"
import script from "./NswEventsTemplate.vue?vue&type=script&lang=js"
export * from "./NswEventsTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports